import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Discount from '@/resources/components/discount/Discount';
import BgImage from '@/resources/components/global/Image/BgImage';
import FreeShippingAlert from '@/resources/components/product/freeShippingAlert/FreeShippingAlert';
import Price from '@/resources/components/product/price/Price';

import { COMBO_STYLES, DesktopComboProductProps } from './types';
import { shouldShowVariations } from './utils';

export function DesktopComboProduct({
  product,
  info,
  dimensions,
  className = '',
}: DesktopComboProductProps) {
  const { title, min_quantity, variations_count, discountPrice, link } = info;
  const { width, height } = dimensions;
  return (
    <div className={`product-card vertical-product ${className}`}>
      <Link to={link} className="w-100">
        <div className="product-wrapper">
          <div style={{ height, width }}>
            <Container fluid>
              <Row className="d-flex justify-content-between align-items-center">
                <Col
                  xs={10}
                  md={8}
                  className="d-flex flex-column pb-4 pl-0"
                  style={{ height: COMBO_STYLES.DESKTOP.containerHeight }}
                >
                  <Col xs={2} md={2} className="my-auto px-0 mr-3">
                    <div className="image-wrapper position-relative">
                      <BgImage className="image" src={product.image} />
                    </div>
                  </Col>

                  <FreeShippingAlert delivery_discount_data={product.delivery_discount_data} />

                  <div className="w-100">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="d-flex flex-column">
                        <div className="d-flex align-items-baseline">
                          <h1 className="combo-title mb-0">{title}</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Discount
                  type="tag"
                  isAbsolute
                  price={discountPrice}
                  defaultPrice={product.price}
                  style={COMBO_STYLES.DESKTOP.discountPosition}
                />

                <div
                  className="d-flex flex-column justify-content-end align-items-start"
                  style={COMBO_STYLES.DESKTOP.quantityPosition}
                >
                  <span>{min_quantity} un</span>
                  {shouldShowVariations(variations_count) && (
                    <span> +{variations_count} Variações</span>
                  )}
                </div>

                <div style={COMBO_STYLES.DESKTOP.pricePosition}>
                  <div className="d-flex d-md-block flex-row-reverse align-items-end">
                    <Price
                      price={discountPrice}
                      defaultPrice={product.price}
                      priceStyles={{ flexDirection: 'column', alignItems: 'flex-end' }}
                    />
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </div>
      </Link>
    </div>
  );
}
